import React from "react";

const Share: React.FC<React.SVGProps<SVGSVGElement>> = ({ width = 18, height = 18, ...props }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			role="img"
			aria-label="Share icon"
			{...props}
		>
			<path
				d="M14.25 11.5C13.4922 11.5 12.8203 11.8281 12.3516 12.3438L6.16406 8.82812C6.19531 8.66406 6.21875 8.5 6.21875 8.32812C6.21875 8.15625 6.19531 7.99219 6.16406 7.82812L12.2734 4.35156C12.7578 4.90625 13.4609 5.25 14.25 5.25C15.7656 5.25 17 4.01562 17 2.5C17 0.984375 15.7656 -0.25 14.25 -0.25C12.7344 -0.25 11.5 0.984375 11.5 2.5C11.5 2.67188 11.5234 2.83594 11.5547 3L5.44531 6.47656C4.96094 5.92188 4.25781 5.57812 3.46875 5.57812C1.95312 5.57812 0.71875 6.8125 0.71875 8.32812C0.71875 9.84375 1.95312 11.0781 3.46875 11.0781C4.25781 11.0781 4.96094 10.7344 5.44531 10.1797L11.6328 13.6953C11.6016 13.8516 11.5781 14.0156 11.5781 14.1875C11.5781 15.6641 12.7734 16.8594 14.25 16.8594C15.7266 16.8594 16.9219 15.6641 16.9219 14.1875C16.9219 12.7109 15.7266 11.5156 14.25 11.5156V11.5Z"
				fill="#222222"
				transform="translate(0.5, 0.75)"
			/>
		</svg>
	);
};

export default Share;
